"use client"
 
import { Checkbox as CheckboxMain } from "@/components/ui/checkbox"

interface CheckboxProps {
  title?: string
  description?: string
  checked?: boolean
  onChange?: () => void
  disabled?: boolean
  required?: boolean
}

export default function Checkbox({ title = 'Сонгох', description ='aa', checked = false, onChange, disabled = false, required = false }: CheckboxProps) {
  return (
    <div className="items-top flex space-x-2">
      <CheckboxMain checked={checked} onCheckedChange={onChange} disabled={disabled} />
      <div className="grid gap-1.5 leading-none">
        <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70" >
          {title}{required && (<span className='text-red-500 ml-1'>*</span>)}
        </label>
        { description && (
          <p className="text-sm text-muted-foreground">
            {description}
          </p>
        ) }
      </div>
    </div>
  )
}